import React, { useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default images when no custom images are set
const defaultBackgroundImages = [
  // Hip Hop / Concert
  "https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?w=300&q=50",
  "https://images.unsplash.com/photo-1514320291840-2e0a9bf2a9ae?w=300&q=50",
  "https://images.pexels.com/photos/972383/pexels-photo-972383.jpeg?w=300",
  "https://images.unsplash.com/photo-1770155496947-c2b056924087?w=300&q=50",
  
  // Vinyl / DJ
  "https://images.pexels.com/photos/18426998/pexels-photo-18426998.jpeg?w=300",
  "https://images.unsplash.com/photo-1571330735066-03aaa9429d89?w=300&q=50",
  "https://images.unsplash.com/photo-1461784180009-21121b2f204c?w=300&q=50",
  
  // Afrobeat / Culture
  "https://images.unsplash.com/photo-1566570078639-5621a0ed9b76?w=300&q=50",
  "https://images.unsplash.com/photo-1516450360452-9312f5e86fc7?w=300&q=50",
  "https://images.unsplash.com/photo-1459749411175-04bf5292ceea?w=300&q=50",
  
  // More music vibes
  "https://images.unsplash.com/photo-1508700115892-45ecd05ae2ad?w=300&q=50",
  "https://images.unsplash.com/photo-1524368535928-5b5e00ddc76b?w=300&q=50",
  "https://images.unsplash.com/photo-1501386761578-eac5c94b800a?w=300&q=50",
  "https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?w=300&q=50",
  "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=300&q=50",
  "https://images.unsplash.com/photo-1598387993281-cecf8b71a8f8?w=300&q=50",
];

export const CultureBackground = () => {
  const [images, setImages] = useState(defaultBackgroundImages);

  useEffect(() => {
    fetchCustomImages();
  }, []);

  const fetchCustomImages = async () => {
    try {
      const response = await axios.get(`${API}/background-images`);
      const customImages = response.data || [];
      
      // If custom images exist, use them; otherwise keep defaults
      if (customImages.length > 0) {
        // If less than 16 custom images, pad with defaults
        if (customImages.length < 16) {
          const combinedImages = [
            ...customImages,
            ...defaultBackgroundImages.slice(0, 16 - customImages.length)
          ];
          setImages(combinedImages);
        } else {
          setImages(customImages.slice(0, 20)); // Max 20 images
        }
      }
    } catch (error) {
      // Keep default images on error
      console.log("Using default background images");
    }
  };

  return (
    <div className="culture-bg-container">
      {/* Multiple layers of images for the mosaic effect */}
      <div className="culture-bg-grid">
        {images.map((img, index) => (
          <div 
            key={index}
            className="culture-bg-item"
            style={{
              backgroundImage: `url(${img})`,
              animationDelay: `${index * 0.3}s`
            }}
          />
        ))}
      </div>
      
      {/* Brown overlay to maintain the theme */}
      <div className="culture-bg-overlay" />
    </div>
  );
};
